import { ChevronsUpDown, KeyRound, LogOut, Moon, Sun, SunMoon } from 'lucide-react'
import { useNavigate } from 'react-router-dom'

import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuGroup,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuSub,
  DropdownMenuSubContent,
  DropdownMenuSubTrigger,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu'
import {
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
  useSidebar,
} from '@/components/ui/sidebar'
import { useAuth } from '@/hooks/use-auth'
import { messages } from '@/lib/messages'
import { useAuthStore } from '@/stores/auth-store'
import { type ThemeMode, useThemeStore } from '@/stores/theme-store'

const THEMES: { mode: ThemeMode; icon: typeof Sun; label: string }[] = [
  { mode: 'light', icon: Sun, label: messages.theme.light },
  { mode: 'dark', icon: Moon, label: messages.theme.dark },
  { mode: 'system', icon: SunMoon, label: messages.theme.system },
]

/** Kenar menü altındaki kullanıcı menüsü: tema, parola değiştir, çıkış. */
export function NavUser() {
  const identity = useAuthStore((state) => state.identity)
  const setTheme = useThemeStore((state) => state.setTheme)
  const { logout } = useAuth()
  const navigate = useNavigate()
  const { isMobile } = useSidebar()

  if (!identity) return null

  return (
    <SidebarMenu>
      <SidebarMenuItem>
        <DropdownMenu>
          <DropdownMenuTrigger
            render={<SidebarMenuButton size="lg" aria-label={messages.common.userMenu} />}
          >
            {/* uiarc user-menu yüzü: 32 px yuvarlak baş harf, ince iç çerçeve. */}
            <span className="bg-surface-muted text-text-secondary grid size-8 shrink-0 place-items-center rounded-full text-[11.5px] leading-none font-medium outline-1 -outline-offset-1 outline-[color-mix(in_oklab,var(--foreground)_9%,transparent)]">
              {identity.full_name.trim().charAt(0).toLocaleUpperCase('tr-TR')}
            </span>
            <span className="grid min-w-0 flex-1 gap-0.5 text-left leading-tight">
              <span className="truncate font-medium">{identity.full_name}</span>
              <span className="text-text-muted truncate text-xs">{identity.email}</span>
            </span>
            <ChevronsUpDown className="text-text-muted group-hover/menu-button:text-foreground group-data-popup-open/menu-button:text-foreground ml-auto transition-colors duration-(--duration-fast)" />
          </DropdownMenuTrigger>
          <DropdownMenuContent
            side={isMobile ? 'bottom' : 'right'}
            align="end"
            className="min-w-56"
          >
            <DropdownMenuGroup>
              <DropdownMenuLabel>{identity.email}</DropdownMenuLabel>
            </DropdownMenuGroup>
            <DropdownMenuSeparator />
            <DropdownMenuSub>
              <DropdownMenuSubTrigger>
                <SunMoon /> {messages.theme.label}
              </DropdownMenuSubTrigger>
              <DropdownMenuSubContent>
                {THEMES.map(({ mode, icon: Icon, label }) => (
                  <DropdownMenuItem key={mode} onClick={() => setTheme(mode)}>
                    <Icon /> {label}
                  </DropdownMenuItem>
                ))}
              </DropdownMenuSubContent>
            </DropdownMenuSub>
            <DropdownMenuItem onClick={() => navigate('/hesap/parola')}>
              <KeyRound /> {messages.auth.changePassword}
            </DropdownMenuItem>
            <DropdownMenuItem
              onClick={() => {
                void logout().then(() => navigate('/giris', { replace: true }))
              }}
            >
              <LogOut /> {messages.auth.logout}
            </DropdownMenuItem>
          </DropdownMenuContent>
        </DropdownMenu>
      </SidebarMenuItem>
    </SidebarMenu>
  )
}
